<p-dialog [(visible)]="displayModal" [style]="{width: '70vw'}"  [modal]="true" [focusOnShow]="false" [closable]="true" (onHide)="closeModal()">
  <ng-template pTemplate="header">
    <div class="p-text-center w-100">
      <h5 class="p-mb-0">
        <span *ngIf="!isEditHeader">{{formHeader}}</span>
        <input type="text" class="inline-text header-width" pInputText *ngIf="isEditHeader"
          placeholder="Enter Form Name" [(ngModel)]="formHeader" />
        <span class="btnBars p-ml-2" *ngIf="!isEditHeader" (click)="isEditHeader = true">
          <i class="pi pi-pencil"></i>
        </span>
        <span class="btnBars p-ml-2" *ngIf="isEditHeader&&formHeader?.length>0" (click)="validateFormName();">
          <i class="pi pi-check"></i>
        </span>
      </h5>
      <div *ngIf="formNameError">
        <p *ngIf="formNameError" class="p-error">{{formNameError}}</p>
      </div>
      <div *ngFor="let d of description;let i=index;">
        <h6 class="p-mt-2 p-mb-0" *ngIf="i==0 && d.description !== ''">{{d.description}}</h6>
        <p class="p-mt-2 p-mb-0" *ngIf="i!==0 && d.description !== ''">{{d.description}}</p>
      </div>
    </div>
    <!-- <div style="display: flex; align-items: center; gap: 1rem; position: relative;">
      <div (click)=" overlayPanel.toggle($event)" 
           style="display: flex; align-items: center; cursor: pointer;">
        <i class="pi pi-palette" 
          [pTooltip]="'Select Theme'" tooltipPosition="top"
           [ngStyle]="{'color': selectedTheme?.color, 'font-size': '1.5rem'}">
        </i>
      </div>
      <p-overlayPanel #overlayPanel>
        <div *ngFor="let theme of themes" 
             (click)="selectTheme(theme)" 
             [ngStyle]="{'background-color': theme.color, 'color': '#fff', 'padding': '6px', 'border-radius': '4px', 'cursor': 'pointer', 'margin-bottom': '5px', 'min-width':'100px'}">
          {{ theme.name }}
        </div>
      </p-overlayPanel>
    </div>     -->

  </ng-template>
  <hr/>
  <label [for]="descriptionText" class="p-ml-1 p-text-bold">Description</label>
  <p-editor [(ngModel)]="descriptionText" [style]="{'height':'100px'}" [placeholder]="'Enter Description'">
    <p-header>
      <span class="ql-formats">
          <select class="ql-size">
              <option value="small">small</option>
              <option selected></option>
              <option value="large">large</option>
              <option value="huge">huge</option>
          </select>
      </span>
      <span class="ql-formats">
          <select class="ql-size">
              <option value="24px">24</option>
              <option value="48px">48</option>
              <option value="100px">100</option>
              <option value="200px">200</option>
          </select>
      </span>
      <span class="ql-formats">
          <button class="ql-bold" aria-label="Bold"></button>
          <button class="ql-italic" aria-label="Italic"></button>
          <button class="ql-underline" aria-label="Underline"></button>
          <button class="ql-strike" aria-label="Strike"></button>
      </span>
      <span class="ql-formats">
          <select title="Text Color" class="ql-color"></select>
          <span class="ql-format-separator"></span>
          <select title="Background Color" class="ql-background"></select>
      </span>
      <span class="ql-formats">
          <button class="ql-list" value="ordered"></button>
          <button class="ql-list" value="bullet"></button>
          <select title="Text Alignment" class="ql-align">
              <option selected>Gauche</option>
              <option value="center" label="Center"></option>
              <option value="right" label="Right"></option>
              <option value="justify" label="Justify"></option>
          </select>
      </span>
      <span class="ql-formats">
          <button aria-label="Link" class="ql-link"></button>
      </span>
  </p-header>
  </p-editor>
  <div *ngIf="countPlainTextLength(descriptionText)> 2000 || descriptionText?.length>5000 " class="p-error p-mt-1">
    Description length should be less than or equal to 2000 characters.
  </div>
  <hr/>
  <div class="p-fluid" *ngIf="form">
    <form [formGroup]="form">
      <ng-container *ngIf="form.errors?.atLeastOneSelected">
        <div class="error p-mt-1 p-mb-2 p-text-center">
          At least one field must be selected.
        </div>
      </ng-container>
      <ng-container *ngIf="form.errors?.atLeastOneRequired">
        <div class="error p-mt-1 p-mb-2 p-text-center">
          At least one field must be required.
        </div>
      </ng-container>
      <div class="p-d-flex p-jc-between p-ai-center p-mb-3">
        <div class="p-d-flex p-ai-center">
          <p-checkbox [formControlName]="'selectAll'" [binary]="true"></p-checkbox>
          <label [for]="'selectAll'" class="p-ml-1 p-text-bold">Select All</label>
        </div>
        <div class="p-d-flex p-ai-center" style="margin-right: 54.62rem;">
          <p-checkbox [formControlName]="'selectAllRequired'" [binary]="true"></p-checkbox>
          <label [for]="'selectAllRequired'" class="p-ml-1 p-text-bold">Required All</label>
        </div>
      </div>
   
      <div cdkDropList class="form-fields p-grid" (cdkDropListDropped)="drop($event)">
        <ng-container *ngFor="let column of updatedColumnDefinitions; let i = index">
          <div class="p-col-12 p-md-6">
            <div class="field-item" cdkDrag>
              <div class="p-d-flex p-jc-between p-ai-center">
                <div class="p-d-flex p-ai-center p-gap-2">
                  <p-checkbox [formControlName]="'checkbox_'+column?.id" [binary]="true"   (onChange)="onCheckboxChange(column?.id)"></p-checkbox>
                  <label [for]="column.name" class="p-ml-1 p-text-bold">{{ column.name }}<span *ngIf="isRequiredChecked(column?.id)" style="color: red;"> *</span></label>
                </div>
                <div class="p-d-flex p-ai-center p-gap-2">
                  <p-checkbox [formControlName]="'isRequired_'+column?.id" [binary]="true"   [disabled]="!isCheckboxChecked(column?.id)"></p-checkbox>
                  <label [for]="'isRequired_'+column?.id" class="p-ml-1 p-text-bold">Required</label>
                </div>
              </div>
              <ng-container [ngSwitch]="column?.formControlName">
                <ng-container *ngSwitchCase="'InputBox'">
                  <input pInputText [formControlName]="column?.id" placeholder="Text Input Type" />
                </ng-container>
                <ng-container *ngSwitchCase="'DropDownList'">
                  <p-dropdown [options]="column.pickListValues" [formControlName]="column?.id"
                    placeholder="Dropdown Input Type"></p-dropdown>
                </ng-container>
                <ng-container *ngSwitchCase="'Number'">
                  <p-inputNumber [formControlName]="column?.id" placeholder="Number Input Type"></p-inputNumber>
                </ng-container>
                <ng-container *ngSwitchCase="'Decimal'">
                  <input pInputText [formControlName]="column?.id" placeholder="Decimal Input Type" />
                </ng-container>
                <ng-container *ngSwitchCase="'Percentage'">
                  <input pInputText [formControlName]="column?.id" placeholder="Decimal Input Type" />
                </ng-container>
                <ng-container *ngSwitchCase="'DatePicker'">
                  <p-calendar [formControlName]="column?.id" [showIcon]="true" [readonlyInput]="true"
                    placeholder="Date Input Type"></p-calendar>
                </ng-container>
                <ng-container *ngSwitchCase="'DateTimePicker'">
                  <p-calendar [formControlName]="column?.id" [showIcon]="true" [readonlyInput]="true"
                    placeholder="Date & Time Input Type"></p-calendar>
                </ng-container>
                <ng-container *ngSwitchCase="'MultipleDropDownList'">
                  <p-dropdown [options]="column?.pickListValues" [formControlName]="column?.id"
                    placeholder="Multi Dropdown Input Type"></p-dropdown>
                </ng-container>
                <ng-container *ngSwitchCase="'Multi-Line'">
                  <textarea pInputTextarea [formControlName]="column?.id" placeholder="Multi-Line Input Type"></textarea>
                </ng-container>
                <ng-container *ngSwitchCase="'CheckBox'">
                  <p-dropdown [options]="column?.pickListValues" [formControlName]="column?.id"
                    placeholder="CheckBox Input Type"></p-dropdown>
                </ng-container>
                <ng-container *ngSwitchCase="'RadioButton'">
                  <p-dropdown [options]="column?.pickListValues" [formControlName]="column?.id"
                    placeholder="Radio Button Input Type"></p-dropdown>
                </ng-container>
                <ng-container *ngSwitchCase="'Rating'">
                  <p-rating [formControlName]="column?.id" [readonly]="true" [cancel]="false" />
                </ng-container>
                <ng-container *ngSwitchCase="'Barcode'">
                  <input pInputText type="text" [formControlName]="column?.id" [readonly]="true"
                    placeholder="Barcode Input Type" />
                </ng-container>
                <ng-container *ngSwitchCase="'ToggleButton'">
                  <!-- <p-toggleButton onLabel="{{ column?.name }}" offLabel="{{ column?.name }}" [onIcon]="'pi pi-check'"
                    [offIcon]="'pi pi-times'" iconPos="right" [readonly]="true" [formControlName]="column?.id">
                  </p-toggleButton> -->
                  <p-inputSwitch [formControlName]="column?.id" />
                </ng-container>
                <ng-container *ngSwitchCase="'FileUpload'">
                  <input pInputText type="text" [formControlName]="column?.id" [readonly]="true"
                    placeholder="File Upload Type" />
                </ng-container>

                <ng-container *ngSwitchCase="'RichText'">
                  <textarea pInputTextarea [formControlName]="column?.id" placeholder="RichText Input Type" 
                  style="max-width:100%"></textarea>
                </ng-container>
                <ng-container *ngSwitchCase="'Picture'">
                  <input pInputText type="text" [formControlName]="column?.id" [readonly]="true"
                    placeholder="Picture Upload Type" />
                </ng-container>
                <ng-container *ngSwitchCase="'Email'">
                  <input pInputText type="text" [formControlName]="column?.id" [readonly]="true"
                    placeholder="Email Input Type" />
                </ng-container>
                <ng-container *ngSwitchCase="'Phone'">
                  <input pInputText type="text" [formControlName]="column?.id" [readonly]="true"
                    placeholder="Phone Input Type" />
                </ng-container>

                <ng-container *ngSwitchCase="'IPAddress'">
                  <input pInputText type="text" [formControlName]="column?.id" [readonly]="true"
                    placeholder="IPAddress Input Type" />
                </ng-container>

                <ng-container *ngSwitchCase="'URL'">
                  <input pInputText type="text" [formControlName]="column?.id" [readonly]="true"
                    placeholder="URL Input Type" />
                </ng-container>
                <ng-container *ngSwitchCase="'EncryptedText'">
                  <input pInputText type="text" [formControlName]="column?.id" [readonly]="true"
                    placeholder="EncryptedText Input Type" />
                </ng-container>
                <ng-container *ngSwitchCase="'Currency'">
                  <input pInputText type="text" [formControlName]="column?.id" [readonly]="true"
                    placeholder="Currency Input Type" />
                </ng-container>
                <ng-container *ngSwitchCase="'Time'">
                  <input pInputText type="time" [formControlName]="column?.id" [readonly]="true"
                    placeholder="Time Input Type" />
                </ng-container>
                <!-- <ng-container *ngSwitchCase="'ngSwitchDefault'">
                  <input pInputText [formControlName]="column?.id" placeholder="Default Input Type" />
                </ng-container> -->
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </div>

  <p-footer>
    
    <button pButton label="Close" (click)="closeModal()" class="p-button-secondary"></button>
    <ng-container *ngIf="!this.formID">
      <button pButton label="Create Form" (click)="saveForm()"
        [disabled]="updatedColumnDefinitions?.length === 0 || isSubmitted || formNameError.length>0 || countPlainTextLength(descriptionText) > 2000 || descriptionText?.length > 5000"></button>
    </ng-container>
    <ng-container *ngIf="this.formID">
      <button pButton label="Update Form" (click)="updateForm()"
        [disabled]="updatedColumnDefinitions?.length === 0 || isSubmitted || formNameError.length>0 || countPlainTextLength(descriptionText) > 2000 || descriptionText?.length > 5000"></button>
    </ng-container>
    <button pButton label="Share form" icon="pi pi-reply" (click)="share.toggle($event)" *ngIf="isShare"></button>
    <p-overlayPanel #share>
      <h6>Share Form link</h6>
      <p-inputGroup>
        <!-- Shareable link -->
        <input type="text" pInputText class="no-border-right" [value]="shareLink" [disabled]="true" />
        <p-button label="Copy Link" icon="pi pi-link" (click)="copyLink()" [outlined]="true"
          class="no-border-left p-ml-2" />
      </p-inputGroup>
      <hr>
      <h6>Embed Iframe</h6>
      <p-inputGroup>
        <!-- Embed iframe code -->
        <textarea pInputTextarea rows="5" [disabled]="true" [value]="iframeCode" class="embed-code-textarea">
      </textarea>
        <button type="button" pButton label="Copy Code" class="p-d-block p-ml-auto p-mr-0 p-mt-2" icon="pi pi-code"
          (click)="copyEmbedCode()" [outlined]="true"></button>
      </p-inputGroup>
      <hr>

      <ul class="link-setting">
        <li class="p-d-flex p-jc-between p-ai-center cursor-pointer" (click)="isLinkSetting = !isLinkSetting">
          <div class="p-d-flex p-jc-center p-ai-center">
            <span class="pi pi-cog p-mr-2" style="color:var(--primary-color)"></span>
            <strong>Link Settings</strong>
          </div>
          <span class="pi pi-angle-right"></span>
        </li>
        <!-- Password restriction -->
        <li *ngIf="isLinkSetting" class="p-py-1">
          <div *ngFor="let linkSetting of linkSettings" class="p-my-2 p-d-flex p-ai-center">
            <p-radioButton [inputId]="linkSetting.key" name="linkSetting" [value]="linkSetting"
              [(ngModel)]="selectedLinkSetting" />
            <label [for]="linkSetting.key" class="p-mr-2 p-ml-2">{{ linkSetting.name }}</label>
          </div>
          <hr *ngIf="selectedLinkSetting?.key !== 'password'">
          <ng-container *ngIf="selectedLinkSetting?.key !== 'password'">
            <button class="p-d-block p-ml-auto p-mr-0 p-mt-2" pButton label="Update Authentication"
              (click)="updateAuthentication()" [disabled]="isSubmitted"></button>
          </ng-container>
          <div class="p-mt-3" *ngIf="selectedLinkSetting?.key === 'password'">
            <div class="input-group">
              <input [type]="passwordFieldType" pInputText class="w-100" placeholder="Enter password"
                #passwordInput="ngModel" [(ngModel)]="formPassword" minlength="4" maxlength="30" required
                (ngModelChange)="validateNoSpaces(passwordInput)" />
              <i class="pi" [ngClass]="passwordFieldType === 'password' ? 'pi-eye' : 'pi-eye-slash'"
                (click)="togglePasswordVisibility()" style="cursor: pointer; margin-left: -30px; margin-top: 5px;">
              </i>
            </div>
            <div class="p-mt-2" *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)">
              <small class="p-error" *ngIf="passwordInput.errors?.required">Password is required.</small>
              <small class="p-error" *ngIf="passwordInput.errors?.minlength">Password must be at least 4
                characters.</small>
              <small class="p-error" *ngIf="passwordInput.errors?.maxlength">Password cannot exceed 30
                characters.</small>
              <small class="p-error" *ngIf="passwordInput.errors?.noSpaces">Password cannot contain spaces.</small>
            </div>
            <hr *ngIf="selectedLinkSetting?.key === 'password'">
            <button class="p-d-block p-ml-auto p-mr-0 p-mt-2" pButton label="Update Authentication"
              (click)="updateAuthentication()" [disabled]="passwordInput?.invalid || isSubmitted"></button>
          </div>
        </li>
      </ul>
    </p-overlayPanel>
  </p-footer>
</p-dialog>

<!-- <p-dialog header="Description" [(visible)]="displayAddDescription" [style]="{width: '45vw'}" [modal]="true">
  <div class="card">
    <div class="p-grid">
      <div class="p-col-12" *ngFor="let d of tempDescription;let i=index;">
        <label>Line {{i+1}}</label>
        <input type="text" pInputText [(ngModel)]="d.description" />
      </div>
    </div>
  </div>
  <p-footer>
    <button label="Cancel" class="p-button-secondary" pButton (click)="displayAddDescription=false"></button>
    <button label="Save" pButton (click)="saveDescription()"></button>
  </p-footer>
</p-dialog> -->